import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-file-loader-skeleton',
  templateUrl: './file-loader-skeleton.component.html'
})
export class FileLoaderSkeletonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
